<script setup lang="ts">
import type { PoliciesTabsProps } from '@/pages/policies/model/types/policies';

withDefaults(defineProps<PoliciesTabsProps>(), {
  activeSlug: '',
});

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['policies-tabs', { _mobile: isMobile }]" data-testid="policies-tabs">
    <ul class="policies-tabs__list">
      <li
        v-for="tab in tabList"
        :key="tab.id"
        :class="['policies-tabs__item', { _active: tab.slug === activeSlug }]"
      >
        <NuxtLink class="policies-tabs__item-label" :to="tab.link">
          {{ tab.label }}
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<style lang="less">
.policies-tabs {
  &__list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: @size-x5;
  }

  &__item {
    display: flex;
    align-items: center;
    position: relative;
    background: #ffffff;
    border: 1px solid @color-alto;
    border-radius: @main-size;
    flex: 1 1 auto;

    &._active {
      background-color: @color-sauvignon;
      border: 1px solid @color-persimmon;
    }
  }

  &__item-label {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    line-height: 130%;
    width: 100%;
    height: 100%;
    cursor: pointer;
    padding: @size-x5;
  }

  &._mobile &__list {
    display: flex;
    flex-direction: column;
    gap: @size-x2;
  }

  &._mobile &__item {
    border-radius: @main-size;
    flex: none;
    width: 100%;
  }
}
</style>
